module.exports = __webpack_public_path__ + "static/header3-eb74284cef101ee73e84af8e649bde69.png";